import { Box, IconButton } from '@mui/material'
import { FC, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import CheckIcon from './../../../../assets/icons/Check.svg?react'
import CopyIcon from './../../../../assets/icons/Copy.svg?react'
interface Props {
    text: string
    onClick: (text: string) => void
}

const Suggestion: FC<Props> = ({ text, onClick }) => {
    const [isCopied, setIsCopied] = useState(false)

    const handleOnClick = () => {
        onClick(text)
    }

    const handleOnClickCopy = (evt: MouseEvent | TouchEvent) => {
        evt.stopPropagation()
        setIsCopied(true)
        setTimeout(() => {
            setIsCopied(false)
        }, 2000)
    }

    return (
        <Box
            onClick={handleOnClick}
            sx={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                borderRadius: '8px',
                padding: '8px 12px',
                border: '1px solid #E7E8EE',
                cursor: 'pointer',
                ':hover': {
                    backgroundColor: '#F9FAFB',
                },
            }}>
            {text}
            <IconButton
                onClick={handleOnClickCopy}
                size="small"
                sx={{
                    backgroundColor: '#F9FAFB',
                    padding: '4px',
                }}
                edge="end">
                <CopyToClipboard text={text}>
                    {!isCopied ? <CopyIcon color="#5A5F72" /> : <CheckIcon color="#5A5F72" />}
                </CopyToClipboard>
            </IconButton>
        </Box>
    )
}

export default Suggestion
